import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FilterState, FilterStateDocumenti, FilterStateIspezioni, FilterStateNonConformita, FilterStateOrdini, FilterStateSvincoli, FilterDettaglioOrdine, FilterStateNotifiche } from '../shared/interfaces/breadcrumb.constants';

@Injectable({ providedIn: 'root' })
export class BreadcrumbService {
  private customLabel$ = new BehaviorSubject<string | null>(null);
  private breadcrumbFilter!: FilterState;
  private breadcrumbList$ = new BehaviorSubject<
    { label: string; url: string | null }[] | null
  >(null);

  setCustomLabel(label: string) {
    this.customLabel$.next(label);
  }

  initBreadcrumbFilter() {
    const savedFilter = sessionStorage.getItem('breadcrumbFilter');
    if (savedFilter) {
      this.breadcrumbFilter = JSON.parse(savedFilter);
    }
    else {
        this.breadcrumbFilter =  { ordini: {} as FilterStateOrdini, ispezioni: {} as FilterStateIspezioni, svincoli: {} as FilterStateSvincoli, nonConformita: {} as FilterStateNonConformita, documenti: {} as FilterStateDocumenti, notifiche: {} as FilterStateNotifiche, fromBreadcrumb: false, dettaglioOrdine: {} as FilterDettaglioOrdine };
    }
  }

  resetBreadcrumbFilter() {
    this.breadcrumbFilter = { ordini: {} as FilterStateOrdini, ispezioni: {} as FilterStateIspezioni, svincoli: {} as FilterStateSvincoli, nonConformita: {} as FilterStateNonConformita, documenti: {} as FilterStateDocumenti, notifiche: {} as FilterStateNotifiche, fromBreadcrumb: false, dettaglioOrdine: {} as FilterDettaglioOrdine };
    sessionStorage.removeItem('breadcrumbFilter');
  }

  setBreadcrumb(list: { label: string; url: string | null }[]) {
    this.breadcrumbList$.next(list);
    this.customLabel$.next(null);
  }

  setFromBreadcrumb(fromBreadcrumb: boolean) {
    this.breadcrumbFilter.fromBreadcrumb = fromBreadcrumb;
    sessionStorage.setItem('breadcrumbFilter', JSON.stringify(this.breadcrumbFilter));
  }

  getFromBreadcrumb() {
    return this.breadcrumbFilter.fromBreadcrumb;
  }

  setFilterOrdini(filter: FilterStateOrdini) {
      this.breadcrumbFilter.ordini = filter;
      sessionStorage.setItem('breadcrumbFilter', JSON.stringify(this.breadcrumbFilter));
  }

  getFilterOrdini() {
    return this.breadcrumbFilter.ordini;
  }

  setFilterIspezioni(filter: FilterStateIspezioni) {
    this.breadcrumbFilter.ispezioni = filter;
    sessionStorage.setItem('breadcrumbFilter', JSON.stringify(this.breadcrumbFilter));
  }

  getFilterIspezioni() {
    return this.breadcrumbFilter.ispezioni;
  }

  setFilterSvincoli(filter: FilterStateSvincoli) {
    this.breadcrumbFilter.svincoli = filter;
    sessionStorage.setItem('breadcrumbFilter', JSON.stringify(this.breadcrumbFilter));
  }

  getFilterSvincoli() {
    return this.breadcrumbFilter.svincoli;
  }

  setFilterNonConformita(filter: FilterStateNonConformita) {
    this.breadcrumbFilter.nonConformita = filter;
    sessionStorage.setItem('breadcrumbFilter', JSON.stringify(this.breadcrumbFilter));
  }

  getFilterNonConformita() {
    return this.breadcrumbFilter.nonConformita;
  }

  setFilterDocumenti(filter: FilterStateDocumenti) {
    this.breadcrumbFilter.documenti = filter;
    sessionStorage.setItem('breadcrumbFilter', JSON.stringify(this.breadcrumbFilter));
  }

  getFilterDocumenti() {
    return this.breadcrumbFilter.documenti;
  }

  setFilterNotifiche(filter: FilterStateNotifiche) {
    this.breadcrumbFilter.notifiche = filter;
    sessionStorage.setItem('breadcrumbFilter', JSON.stringify(this.breadcrumbFilter));
  }

  getFilterNotifiche() {
    return this.breadcrumbFilter.notifiche;
  }

  getFilterDettaglioOrdine() {
    return this.breadcrumbFilter.dettaglioOrdine;
  }

  setFilterDettaglioOrdine(filter: FilterDettaglioOrdine) {
    this.breadcrumbFilter.dettaglioOrdine = filter;
    sessionStorage.setItem('breadcrumbFilter', JSON.stringify(this.breadcrumbFilter));
  }

  getBreadcrumb() {
    return this.breadcrumbList$.asObservable();
  }

  getCustomLabel() {
    return this.customLabel$.asObservable();
  }

  clear() {
    this.customLabel$.next(null);
    this.breadcrumbList$.next(null);
  }
}
